export default __webpack_public_path__ + "static/lalibrairie-c-desktop@2x-b1993c286b82c84944c1eddb3c7d5069.jpg";